import { GetStaticPaths, GetStaticProps } from "next";
import parlors from "goi_common/src/constants/parlors_detail.json";
import { parlorRegion } from "@/constants/parlorRegion";
import {
  BTypeCompareParlor,
  EXCLUDED_IDS_BY_REGION,
  ParlorDetailProps,
  sangjoFaqRichSearch,
} from "goi_common";
import { Box, Stack } from "@mui/material";
import Head from "next/head";

const { regionColor, targetSidos } = parlorRegion;

export const getParlorComparisionPathList = () => {
  const excludedSet = EXCLUDED_IDS_BY_REGION.metro ?? new Set<number>();

  const parlorList = parlors
    .filter((res) => targetSidos.includes(res.sido))
    .filter((res) => !excludedSet.has(res.id));

  let pathList = [] as Array<any>;
  let copyParlorList = [...parlorList];

  while (copyParlorList.length > 0) {
    let firstParlor = copyParlorList[0];

    if (excludedSet.has(firstParlor.id)) {
      copyParlorList.shift();
      continue;
    }
    
    copyParlorList.map((secondParlor) => {
      if (
        firstParlor.id !== secondParlor.id &&
        (secondParlor.sido === "11"
          ? true
          : firstParlor.sigungu === secondParlor.sigungu)
      ) {
        pathList.push({
          params: {
            firstplace: String(firstParlor.id),
            secondplace: String(secondParlor.id),
          },
        });
      }
    });
    copyParlorList.shift();
  }

  return pathList;
};

export const getStaticPaths: GetStaticPaths = async () => {
  // const parlorList = parlors.filter((res) => targetSidos.includes(res.sido));

  // let pathList = [] as Array<any>;
  // let copyParlorList = [...parlorList];

  // while (copyParlorList.length > 0) {
  //   let firstParlor = copyParlorList[0];
  //   copyParlorList.map((secondParlor) => {
  //     if (
  //       firstParlor.id !== secondParlor.id &&
  //       (secondParlor.sido === "11"
  //         ? true
  //         : firstParlor.sigungu === secondParlor.sigungu)
  //     ) {
  //       pathList.push({
  //         params: {
  //           firstplace: String(firstParlor.id),
  //           secondplace: String(secondParlor.id),
  //         },
  //       });
  //     }
  //   });
  //   copyParlorList.shift();
  // }

  const pathList = getParlorComparisionPathList();

  return {
    paths: pathList,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const firstplace = params?.firstplace as string;
  const secondplace = params?.secondplace as string;

  const firstParlor = parlors.filter(
    (p) => String(p.id) === String(firstplace)
  )[0];
  const secondParlor = parlors.filter(
    (p) => String(p.id) === String(secondplace)
  )[0];

  let description = `장례식장들의 여러 대안을 준비해두는 것은 중요합니다. 본 글에서는
    ${firstParlor.companyname}과 ${secondParlor.companyname}을 비교
  해보겠습니다. (고이장례연구소, e하늘 장사정보시스템 기반)`;

  return {
    props: {
      firstParlor,
      secondParlor,
      pageDescription: description,
      pageKeywords: `${firstParlor.companyname} 장례 서비스, ${firstParlor.companyname} 얼마, ${firstParlor.companyname} 앰뷸런스, ${firstParlor.companyname} 수의, ${firstParlor.companyname} 유골함, ${firstParlor.companyname} 도우미, ${firstParlor.companyname} 비용, ${firstParlor.companyname} 할인, ${firstParlor.companyname} 전화번호,
      ${secondParlor.companyname} 장례 서비스, ${secondParlor.companyname} 얼마, ${secondParlor.companyname} 앰뷸런스, ${secondParlor.companyname} 수의, ${secondParlor.companyname} 유골함, ${secondParlor.companyname} 도우미, ${secondParlor.companyname} 비용, ${secondParlor.companyname} 할인, ${secondParlor.companyname} 전화번호`,
      pageOgTitle: `${firstParlor.companyname} vs ${secondParlor.companyname} 비교 | 서울경기인천장례정보 [고이장례연구소]`,
      pageOgDescription: description,
      pageOgImage: firstParlor?.images[0]?.url || "",
    },
  };
};

export default function placeComaprePage({
  firstParlor,
  secondParlor,
  pageOgTitle,
}: {
  firstParlor: ParlorDetailProps;
  secondParlor: ParlorDetailProps;
  pageOgTitle: string;
}) {
  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(sangjoFaqRichSearch),
          }}
        />
      </Head>
      <Stack>
        <BTypeCompareParlor
          firstParlor={firstParlor}
          secondParlor={secondParlor}
          mainColor={regionColor}
        />
      </Stack>
    </>
  );
}
